import Card from "./card.js";
export default class ImageOnly extends Card {
  constructor(s, t, i, h, r, e, l, n, o, a, u, c, d, m) {
    super(s, t, null, i, null, h, r, e, l, n, o, a, u, c, d, m),
      (this.oe = "ab-image-only"),
      (this.ae = !1),
      (this.test = !1);
  }
  bt() {
    const s = {};
    return (
      (s[Card.es.hs] = Card.cs.ai),
      (s[Card.es.ds] = this.id),
      (s[Card.es.ps] = this.viewed),
      (s[Card.es.ls] = this.imageUrl),
      (s[Card.es.xs] = this.updated),
      (s[Card.es.bs] = this.created),
      (s[Card.es.gs] = this.categories),
      (s[Card.es.js] = this.expiresAt),
      (s[Card.es.URL] = this.url),
      (s[Card.es.zs] = this.linkText),
      (s[Card.es.ks] = this.aspectRatio),
      (s[Card.es.qs] = this.extras),
      (s[Card.es.vs] = this.pinned),
      (s[Card.es.ws] = this.dismissible),
      (s[Card.es.ys] = this.clicked),
      (s[Card.es.As] = this.test),
      s
    );
  }
}
